// Notification preferences service: load/save prefs and handle browser push setup

const LOCAL_STORAGE_KEY = 'notificationPrefs';

export const DEFAULT_PREFS = {
  coachingReminders: false,
  coachingRemindersTime: '09:00',
  coachingRemindersDays: ['Mon', 'Wed', 'Fri'],
  dailyInsights: false,
  dailyInsightsTime: '08:00',
  topics: '',
  lifeAndWellbeing: false,
  emailNotifications: false,
  pushNotifications: false,
};

export function loadNotificationPrefs() {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PREFS, ...parsed };
  } catch (e) {
    console.warn('Failed to load notification prefs', e);
    return { ...DEFAULT_PREFS };
  }
}

export function saveNotificationPrefs(prefs) {
  try {
    const merged = { ...DEFAULT_PREFS, ...prefs };
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(merged));
    return merged;
  } catch (e) {
    console.warn('Failed to save notification prefs', e);
    return prefs;
  }
}

export function arePushSupported() {
  return typeof window !== 'undefined' && 'Notification' in window && 'serviceWorker' in navigator;
}

export async function ensurePushPermission() {
  if (!arePushSupported()) {
    return { granted: false, reason: 'unsupported' };
  }
  let permission = Notification.permission;
  if (permission === 'default') {
    try {
      permission = await Notification.requestPermission();
    } catch (e) {
      return { granted: false, reason: 'denied' };
    }
  }
  if (permission !== 'granted') {
    return { granted: false, reason: 'denied' };
  }
  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    return { granted: true, registration };
  } catch (e) {
    console.warn('SW registration failed', e);
    return { granted: false, reason: 'sw-failed' };
  }
}

export async function sendLocalTestNotification(title = 'Fidora', body = 'Notifications are enabled!') {
  if (!arePushSupported() || Notification.permission !== 'granted') return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (reg && reg.showNotification) {
      await reg.showNotification(title, {
        body,
        icon: '/fidora_fav1.png',
        badge: '/fidora_fav1.png',
        data: { url: '/' },
      });
      return true;
    }
    // Fallback
    // eslint-disable-next-line no-new
    new Notification(title, { body, icon: '/fidora_fav1.png' });
    return true;
  } catch (e) {
    console.warn('Failed to show test notification', e);
    return false;
  }
}

export async function persistPrefsToBackend(prefs, identity = {}) {
  try {
    const base = process.env.REACT_APP_NOTIF_API_BASE;
    if (!base) return prefs; // no backend configured
    const url = base.endsWith('/') ? `${base}api/notifications/prefs` : `${base}/api/notifications/prefs`;
    const resp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: identity.userId || null, email: identity.email || null, prefs }),
    });
    if (!resp.ok) {
      console.warn('Persist prefs failed', await resp.text());
      return prefs;
    }
    return prefs;
  } catch (e) {
    console.warn('Persist prefs error', e);
    return prefs;
  }
}


